import { ReactComponent as Check } from './check.svg'
import styles from './FilterToggle.module.scss'

const FilterToggle = ({ children, on, onClick, title }) => (
  <div className={on ? styles.toggleOn : styles.toggle} onClick={onClick} title={title}>
    {children}
    {on && <Check />}
  </div>
)

export const FilterDropdownToggle = ({ value, options, onSelect, on }) => {
  return (
    <>
      <select
        className={on ? styles.inputToggleOn : styles.inputToggle}
        onChange={e => onSelect(e.target.value)}
        value={value}
      >
        {options.map(o => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </>
  )
}

export const FilterInput = ({ value, onChange, on, placeholder }) => (
  <input
    type="search"
    className={on ? styles.inputToggleOn : styles.inputToggle}
    value={value}
    onChange={e => onChange(e.target.value)}
    placeholder={placeholder}
  />
)

export default FilterToggle
